module.exports = __webpack_public_path__ + "img/icon-c-withdraw-ls.cf376f54.png";